import React from 'react';
import { Loader2 } from 'lucide-react';

const SIZE_CLASSES = { sm: 'w-4 h-4', md: 'w-6 h-6', lg: 'w-10 h-10' };

export const Spinner = ({ size = 'md', className = '' }) => (
  <Loader2 className={[SIZE_CLASSES[size], 'animate-spin', className].join(' ')} />
);

const TONE_TEXT = { light: 'text-slate-500', dark: 'text-slate-400' };
const TONE_ICON = { light: 'text-themePrimary', dark: 'text-violet-500' };

// The centered "loading…" block reused across every page's data-fetch state.
export const LoadingState = ({ label = 'Loading…', tone = 'light', className = '' }) => (
  <div className={['flex flex-col items-center justify-center gap-3 py-16', className].join(' ')}>
    <Spinner size="lg" className={TONE_ICON[tone]} />
    <p className={['text-sm', TONE_TEXT[tone]].join(' ')}>{label}</p>
  </div>
);

export default Spinner;
